import { DestructiveButton } from 'ui/button';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/modal';

type DisplayContent = {
  header: string | JSX.Element;
  content: string | JSX.Element;
  submitButtonText: string;
  cancelButtonText: string;
  submitButtonAppearance: string;
  cancelButtonAppearance: string;
};

type FacebookIntegrationModalProps = {
  isVisible: boolean;
  buttonSubmitHandler: () => void;
  hideModal: () => void;
  displayContent: DisplayContent;
  buttonDisabled?: boolean;
};

export const FacebookIntegrationModal = ({
  isVisible,
  buttonSubmitHandler,
  displayContent,
  hideModal,
  buttonDisabled = false,
}: FacebookIntegrationModalProps) =>
  isVisible ? (
    <Modal
      id="facebookIntegrationModal"
      data-test="facebook-integration-modal"
      isModalOpen={isVisible}
      onClose={hideModal}
    >
      <ModalHeader>{displayContent.header}</ModalHeader>
      <ModalBody>{displayContent.content}</ModalBody>
      <ModalFooter onClose={hideModal}>
        <DestructiveButton
          isDisabled={buttonDisabled}
          data-test="FacebookIntegrationsModal-Yes"
          onClick={buttonSubmitHandler}
        >
          {displayContent.submitButtonText}
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  ) : null;
